import compact from "lodash/compact";
import keyBy from "lodash/keyBy";
import { ColumnsDisplay } from "PFApp/booking/store";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import { TableData } from "PFComponents/table/table";
import { OrderOption, TableColumn } from "PFTypes";

export enum TablePropertiesTab {
  Engagements = "engagements",
  Roles = "roles",
  Profiles = "profiles"
}

export const getAvailableTabsByCalendarRoot = (calendarRoot: CalendarRoot): TablePropertiesTab[] => {
  if (isWorkforceProfiles(calendarRoot)) {
    return [TablePropertiesTab.Profiles];
  }
  const projectsTabs = {
    [CalendarRoot.ProjectsEngagements]: [TablePropertiesTab.Engagements, TablePropertiesTab.Roles],
    [CalendarRoot.ProjectsRoles]: [TablePropertiesTab.Roles]
  };
  return projectsTabs[calendarRoot] ?? [];
};

const CUSTOM_FIELDS_PREFIX = "custom_fields.";
export const isCustomFieldOption = (name: string = "") => name.startsWith(CUSTOM_FIELDS_PREFIX);

export const resetCustomFieldOrderIfNeeded = ({
  selectedOrder,
  visibleColumns,
  onOrderReset
}: {
  selectedOrder: OrderOption | null;
  visibleColumns: TableData[];
  onOrderReset: VoidFunction;
}) => {
  if (!selectedOrder || selectedOrder.name.length > 1) {
    return;
  }
  const order = selectedOrder.name[0];
  const isCustomFieldOrder = isCustomFieldOption(order);
  const customFieldColumnOrderKeys = visibleColumns
    .filter(({ type }) => type === "custom_field")
    .map(({ orderKey }) => orderKey);
  if (isCustomFieldOrder && !customFieldColumnOrderKeys.includes(order)) {
    onOrderReset();
  }
};

export const getSelectedColumns = (
  availableColumns: TableColumn[],
  selectedNames: string[]
): TableColumn[] => {
  // selected columns order should be preserved
  const availableColumnsByName = keyBy(availableColumns, "name");
  return compact(selectedNames.map((name) => availableColumnsByName[name]));
};

export const getHiddenColumns = (
  availableColumns: TableColumn[],
  { selectedColumns, inlineColumns }: ColumnsDisplay
): TableColumn[] =>
  availableColumns.filter(({ name }) => !selectedColumns.includes(name) && !inlineColumns.includes(name));
